import i18n from '@/i18n'
// @TODO move to the view component, as we use url as a state tool
import router from '@/router'

const state = {
}

const mutations = {
}

const actions = {
  setStep ({ commit, getters, state, dispatch }, stepValue) {
    const step = getters.steps.find(el => el.value === stepValue)
    step
      ? router.push('/cart/' + getters.currentStep.next.step.value)
      : dispatch('resetCartFlow')
  },
  incrementStep ({ commit, state, getters }) {
    router.push('/cart/' + getters.currentStep.next.step.value)
  },
  decrementStep ({ commit, state, getters }) {
    router.push('/cart/' + getters.currentStep.previous.step.value)
  },
  resetCartFlow ({ commit, state, getters }) {
    const step = getters.steps[0]
    router.replace('/cart/' + step.value)
  }
}

const getters = {
  steps: (state, getters, rootState, rootGetters) => {
    const _steps = [
      {
        value: 'review-cart',
        navigationTitle: i18n.t('cart.flow.reviewCart'),
        stepTitle: i18n.t('cart.flow.shoppingCart'),
        pageTitle: i18n.t('cart.flow.cart'),
        next: {
          get step () {
            return rootGetters['user/isGuest']
              ? _steps.find(el => el.value === 'guest-login')
              : _steps.find(el => el.value === 'shipping')
          },
          actionText: i18n.t('cart.flow.continueToShipping')
        },
        previous: {
          get step () {
            return null
          },
          actionText: ''
        },
        hasBreadcrumb: true,
        get crumbData () {
          return { title: `${i18n.t('cart.flow.itemsForPurchase')}: ${rootGetters['cart/cartSize']}` }
        },
        get isAccessible () {
          return true
        }
      },
      {
        value: 'guest-login',
        stepTitle: i18n.t('cart.flow.shoppingCart'),
        pageTitle: i18n.t('cart.flow.cart'),
        next: {
          get step () {
            return _steps.find(el => el.value === 'shipping')
          },
          actionText: i18n.t('cart.flow.continueToShipping')
        },
        previous: {
          get step () {
            return _steps.find(el => el.value === 'review-cart')
          },
          actionText: i18n.t('common.back')
        },
        hasBreadcrumb: false,
        belongsToCrumbStep: 'review-cart',
        get crumbData () {
          return null
        },
        get isAccessible () {
          return rootGetters['user/isGuest'] &&
          !rootGetters['cart/isCartContainsUnavailableProduct'] &&
          !rootState.cart.cartData?.isInvalidPromotionsApplied
        }
      },
      {
        value: 'shipping',
        navigationTitle: i18n.t('cart.flow.shipping'),
        stepTitle: i18n.t('cart.flow.shipping'),
        pageTitle: i18n.t('cart.flow.checkout'),
        next: {
          get step () {
            const stepId = rootState.cart.cartData?.paymentDetails ? 'review-order' : 'billing'
            return _steps.find(el => el.value === stepId)
          },
          actionText: rootState.cart.cartData?.paymentDetails ? i18n.t('cart.flow.reviewOrder') : i18n.t('cart.flow.continueToBilling')
        },
        previous: {
          get step () {
            return _steps.find(el => el.value === 'review-cart')
          },
          actionText: i18n.t('common.back')
        },
        hasBreadcrumb: true,
        get crumbData () {
          return rootState.cart.cartData?.shippingAddress
        },
        get isAccessible () {
          return !!rootState.cart.cartData?.customerUid &&
          !rootGetters['cart/isCartContainsUnavailableProduct'] &&
          !rootState.cart.cartData?.isInvalidPromotionsApplied
        }
      },
      {
        value: 'billing',
        navigationTitle: i18n.t('cart.flow.billing'),
        stepTitle: i18n.t('cart.flow.billing'),
        pageTitle: i18n.t('cart.flow.checkout'),
        next: {
          get step () {
            return _steps.find(el => el.value === 'review-order')
          },
          actionText: i18n.t('cart.flow.reviewOrder')
        },
        previous: {
          get step () {
            return _steps.find(el => el.value === 'shipping')
          },
          actionText: i18n.t('common.back')
        },
        hasBreadcrumb: true,
        get crumbData () {
          return rootState.cart.cartData?.paymentDetails
        },
        get isAccessible () {
          return !!rootState.cart.cartData?.customerUid &&
            !!rootState.cart.cartData?.deliveryMode &&
            !!rootState.cart.cartData?.shippingAddress
        }
      },
      {
        value: 'review-order',
        navigationTitle: i18n.t('cart.flow.reviewOrder'),
        stepTitle: i18n.t('cart.flow.reviewOrder'),
        pageTitle: i18n.t('cart.flow.checkout'),
        next: {
          get step () {
            return null
          },
          actionText: i18n.t('cart.flow.placeOrder')
        },
        previous: {
          get step () {
            const stepId = rootState.cart.cartData?.paymentDetails ? 'shipping' : 'billing'
            return _steps.find(el => el.value === stepId)
          },
          actionText: i18n.t('common.back')
        },
        hasBreadcrumb: true,
        get crumbData () {
          return null
        },
        get isAccessible () {
          return !!rootState.cart.cartData?.customerUid &&
            !!rootState.cart.cartData?.shippingAddress &&
            !!rootState.cart.cartData?.deliveryMode &&
            !!rootState.cart.cartData?.paymentDetails
        }
      }
    ]
    return _steps
  },
  currentStepIndex: (state, getters, rootState) => {
    const stepValue = rootState.route.params.step
    return getters.steps.map(el => el.value).indexOf(stepValue)
  },
  currentStep: (state, getters, rootState) => {
    const stepValue = rootState.route.params.step
    return getters.steps.find(el => el.value === stepValue)
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
}
